import moment from "moment";
import styled, { css } from "styled-components";

import { endpoint } from "views/pages/manage/common/constant";
import { updateRequest } from "views/pages/manage/edpOps/constant/common";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { documentServiceBaseUrl } from "services/http";
import { putpost } from "services/utils";
import { getPaymentModeName } from "../../../../unAssigned/collectPayment/selectPaymentMode/components/constant";

export const searchInputParams = {
  psid: {
    dispValue: "PSID",
    validLength: 11,
    placeholder: "Please Enter 11 digit PSID",
  },

  applicationId: {
    dispValue: "Application ID",
    validLength: 8,
    placeholder: "Please Enter 8 digit Application ID",
  },
};

export const emptySearchFields = {
  psid: "",
  applicationId: "",
};

export const getBusinessAreasDropdown = async () => {
  const res = await fetchAllPromisedData(
    `${endpoint?.businessArea.getAllBusinessAreaList}`
  );

  if (res.length) {
    return res;
  }

  return [];
};

export const getReceiptsList = async ({ payload = {}, page = 0 }) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.manageReceipts.search}?offset=${page}`,
    {
      ...updateRequest(payload),
    },
    "post"
  );

  return response;
};

async function dropdownMapping(url, displayLabel) {
  const responseData = await fetchAllPromisedData(url, false);
  if (displayLabel == "courseTypeList") {
    const result = responseData?.map((obj) => {
      return {
        label: obj.courseAttributeValueDispValue,
        value: obj.courseAttributeValueDispValue,
        id: obj.id,
      };
    });
    return result ?? [];
  }
  if (displayLabel == "receiptTypeList") {
    const result = responseData?.map((obj) => {
      return {
        label: obj.receiptTypeDispValue,
        value: obj.receiptTypeDispValue,
        id: obj.id,
      };
    });
    return result ?? [];
  }
  if (displayLabel == "termList") {
    const result = responseData?.map((obj) => {
      return { label: obj.termDispValue, value: obj.termDispValue, id: obj.id };
    });
    return result ?? [];
  }
}

export const getDropdowns = async () => {
  const p = await Promise.all([
    dropdownMapping(
      `${endpoint.getCourseAttributeValueByCourseType}`,
      "courseTypeList"
    ),
    dropdownMapping(endpoint.getAllActiveReceiptType, "receiptTypeList"),
    dropdownMapping(endpoint.term.getAllActive, "termList"),
  ]);

  return {
    courseTypeList: p[0],
    receiptTypeList: p[1],
    termList: p[2],
  };
};

export const getCourseIdDropdown = async ({
  businessAreaIds,
  academicTermIds,
  courseCategoryType,
}) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.course.getCourseIdByAcademicTermAndBusinessArea}`,
    {
      businessAreaIds,
      academicTermIds,
      courseCategoryType,
    },
    "post"
  );

  if (response?.code === 200)
    return response?.data.map((courseId) => ({
      label: courseId,
      value: courseId,
    }));
  return [];
};

const getUploadUrl = async () => {
  const formData = {
    bulk: false,
    fileName: "paymentReceipt.pdf",
    docType: "pdf",
    sourceId: 1,
    keyValue: new Date(),
    serviceName: "PAYMENT_RECEIPTS",
  };

  const response = await fetchAllPostPromisedData(
    `${documentServiceBaseUrl}/documentManagement/getUploadUrl`,
    formData,
    "post"
  );

  if (response?.code == 200) return response.data;
  return null;
};

export const fetchReceiptDetails = async (receipts = []) => {
  const payload = receipts.map((obj) => ({
    receiptId: obj.receiptId,
    businessArea: obj.businessArea,
    businessAreaId : obj.businessAreaId,
  }));

  //  get receiptDetails
  const response = await fetchAllPostPromisedData(
    `${endpoint.manageReceipts.receiptDetails}`,
    payload,
    "post"
  );

  if (response?.code == 200) return response.data;
  return null;
};

export const printReceipt = async ({ receipts = [],businessAreaOptions=[], getPdf = true }) => {
  // call fetchReceiptDetails API
  debugger
  if(receipts?.length && !receipts[0]?.businessAreaId){
  const businessAreaId = businessAreaOptions.filter(
    (bu) => bu.value === receipts[0].businessArea
  )[0]?.businessAreaId;

  receipts = receipts.map(receipt => ({...receipt, businessAreaId}))
}
  const receiptDetails = await fetchReceiptDetails(receipts);

  if (receiptDetails?.length) {
    // call htmlToPdf API
    const response = await createPaymentReceipt({
      getPdf,
      receiptsInfo: receiptDetails,
      templateName: 'paymentReceiptPrint'
    });

    if (response?.code === 200) {
      const pdfBuffer = response.pdfFile.data;

      const blob = new Blob([new Uint8Array(pdfBuffer)], {
        type: "application/pdf",
      });

      const url = URL.createObjectURL(blob);
      window.open(url);
    }
  }
};

export const sendNotification = async ({ receiptsInfo = [] }) => {
  const s3response = await getUploadUrl();

  if (s3response?.storage) {
    // call htmlToPdf API
    const response = await createPaymentReceipt({
      getPdf: false,
      receiptsInfo,
      uploadUrl: s3response.storage,
      templateName: 'paymentReceiptNotification'
    });

    if (response?.code === 200) {
      return s3response;
    }

    return null;
  }

  return null;
};

export const styles = {
  crossIconStyle: {
    fontSize: "11px",
    position: "absolute",
    top: "0.6rem",
    right: "30px",
    cursor: "pointer",
  },

  SeachWrapper: styled.span`
    svg {
      position: absolute;
      top: 5.5px;
      right: 5px;
      cursor: pointer;
      z-index: 3;
    }
  `,

  ErrorMsg: styled.div`
    color: #dc2804;
    margin-top: 5px;
    margin-left: 12px;
    font-size: 12px;
  `,

  StyledInput: styled.input`
    padding-left: 5px !important;
    width: 370px;

    ${(props) =>
      props.errorMsg &&
      props.searchInputValue?.trim()?.length <
      props.selectedSearchFieldProperties?.validLength &&
      props.searchInputValue?.trim()?.length > 0 &&
      css`
        border: 1px solid #dc2804;
        color: #dc2804;
        :hover:not([disabled]),
        :focus:not([disabled]) {
          border-color: #dc2804 !important;
          color: #dc2804 !important ;
        }
        &:not(:placeholder-shown) {
          color: #dc2804 !important;
        }
      `}
  `,
};

export const commonStyle = {
  fontSize: "12px",
  color: "#414141",
  display: "flex",
};

export const InputLabelStyle = {
  fontFamily: "Gilroy-Regular",
  fontSize: "12px",
  lineHeight: "14px",
  color: "#414141",
  marginTop: "10px",
  fontWeight: "500",
};

export const REACT_ICONS_STYLE = {
  color: "#AFAFAF",
  height: "1.2rem",
  width: "1.2rem",
  cursor: "pointer",
  margin: ".5rem .5rem",
};

const getCreateReceiptTemplateData = (receiptsInfo) => {
  const data = receiptsInfo?.map((receiptInfo) => {
    let totalAmount = 0,
      totalCgst = 0,
      totalSgst = 0,
      totalIgst = 0,
      totalCess = 0,
      totalPaid = 0;

    const {
      receiptDate,
      chargesBreakupDTOList,
      courseIdDescriptionMap,
      courseIds,
      studentGender,
      organizationType,
      gstInNumber,
    } = receiptInfo;

    const courseId = courseIds[0];

    return {
      ...receiptInfo,
      receiptDate: moment(receiptDate).format("DD/MM/YYYY"),
      relation: getStudentRelationWithFather(studentGender),
      chargesBreakupDTOList: chargesBreakupDTOList?.map((el) => {
        const {
          amount,
          cgst,
          sgst,
          igst,
          cess,
          paymentMode,
          particulars,
          date,
        } = el;

        // const total = amount + cgst + sgst + igst + cess;

        // totalAmount += amount;
        // totalCgst += cgst;
        // totalSgst += sgst;
        // totalIgst += igst;
        // totalCess += cess;
        // totalPaid += +total;

        const total = add2DecimalFloats(amount, cgst, sgst, igst, cess);

        totalAmount = add2DecimalFloats(totalAmount, amount);
        totalCgst = add2DecimalFloats(totalCgst, cgst);
        totalSgst = add2DecimalFloats(totalSgst, sgst);
        totalIgst = add2DecimalFloats(totalIgst, igst);
        totalCess = add2DecimalFloats(totalCess, cess);
        totalPaid = add2DecimalFloats(totalPaid, total);

        return {
          ...el,
          amount: formatToIndianLocale(amount),
          total: formatToIndianLocale(roundOff(total)),
          paymentMode: getPaymentModeName(paymentMode),
          particulars: `${particulars} ${date ? moment(date)?.format("DD/MM/YYYY") : ""}`,
        };
      }),
      totalAmount: formatToIndianLocale(totalAmount),
      totalCgst,
      totalSgst,
      totalIgst,
      totalCess,
      totalPaid: roundOff(totalPaid),
      formattedTotalPaid: formatToIndianLocale(roundOff(totalPaid)),
      courseId,
      courseIdDescription: courseIdDescriptionMap[courseId],
      isB2BCase: organizationType === "B2B",
      studentGstInNumber: gstInNumber,
    };
  });

  return {
    receiptsData: data,
    name: "paymentReceipt", //name of the file to be stored on S3
    copiesRequired: ["Student Copy", "Office Copy"], // used for generating two copies on same page in "paymentReceiptPrint" 
  };
};

export const createPaymentReceipt = async ({
  getPdf,
  uploadUrl,
  receiptsInfo,
  templateName
}) => {
  try {
    const reqObj = {
      templateName,
      uploadUrl,
      getPdf,
      templateData: getCreateReceiptTemplateData(receiptsInfo),
    };

    return await fetchAllPostPromisedData(endpoint.createPdf, reqObj);
  } catch (err) {
    console.error(err);
  }
};

export const formatToIndianLocale = (value) => value.toLocaleString("en-IN");

const getStudentRelationWithFather = (studentGender) =>
  studentGender === "M" ? "S/o" : "D/o";

const roundOff = val => Math.round(val);

const add2DecimalFloats = (...numbers) =>
  numbers.reduce((acc, curr) => acc + Math.round(curr * 100), 0) / 100;

export const byPassDateSearchValidationFilters = ['psid','applicationId']